<script>
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import Jewel05 from './Jewel05.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ Jewel05 ],
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,5,6,8,9]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col2>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(10 * 4)" />
    </template>

    <template #col3>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(10 * 4)" :isOrphan="true" />
    </template>

    <template #col4>
    </template>

    <template #col5>
      <ItemList title="ニコチケ二択目 PR ★★★" color="#ffa1bc" :items="itemsNico2PR" />
      <ItemList title="ニコチケ二択目 SR ★★" color="#00c7da" :items="itemsNico2SR | first(5 * 4)" />
    </template>

    <template #col6>
      <ItemList title="ニコチケ二択目 SR ★★" color="#00c7da" :items="itemsNico2SR | rest(5 * 4)" :isOrphan="true" />
    </template>

    <template #col7>
      <ItemList title="ニコチケ二択目 R ★" color="#feab0d" :items="itemsNico2R | first(9 * 4)" />
    </template>

    <template #col8>
      <ItemList title="ニコチケ二択目 R ★" color="#feab0d" :items="itemsNico2R | rest(9 * 4)" />
    </template>

    <template #col9>
      <ItemList title="ニコチケ二択目 N" color="#f6c3b2" :items="itemsNico2N" />
      <ItemList title="スペシャルキラニコチケ|PR ★★★" color="#ffa1bc" :items="itemsSpecialKiraNico" />
      <Status :date="date" :items="items" :showNico="true" />
    </template>

    <template #col10>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: 50px;
  //   }
  // }
</style>
